<template>
  <div class="c-creative">
    <div class="c-smart-wrapper g-clearfix">
      <div v-for="(item, id) in tempalteJson" :key="id" class="">
        <smart-video
          v-if="item.name === 'photo_ids'"
          :value="smartVideo"
          :data="item.children"
          :min="item.restriction.min_length"
          :max="item.restriction.max_length"
          :required="item.required"
          :description="item.description"
          :verify="verify"
          :source="source"
          :scene-id="sceneId"
          :smart-cover="smartCover"
          @smart-change="(e) => (smartCover = e)"
          @select="selectVideo"
          @on-clear="clearVideo"
          @on-select="selectMedia(item.restriction.origin_template, ...arguments)"
          @on-add="selectVidoeMedia(item.restriction.origin_template, ...arguments)"
          @on-delete="delChild(id, ...arguments)"
        />
        <!--    <smart-cover
          v-else-if="item.name === 'cover_image_tokens'"
          v-model="smartCover"
          :data="item.children"
          :min="item.restriction.min_length"
          :max="item.restriction.max_length"
          :required="item.required"
          :description="item.description"
          :verify="verify"
          :source="source"
          :scene-id="sceneId"
          @on-select="selectMedia(...arguments, smartVideo)"
          @on-add="selectImageMedia(item.restriction.origin_template, ...arguments)"
          @on-delete="delChild(id, ...arguments)"
        /> -->
        <smart-sticker
          v-else-if="item.name === 'sticker_styles' && sceneId !== 5"
          :data="item.children"
          :min="item.restriction.min_length"
          :max="item.restriction.max_length"
          :description="item.description"
          :verify="verify"
          :scene-id="sceneId"
          @on-select="selectChild(id, ...arguments)"
        />
        <smart-slog
          v-else-if="item.name === 'cover_slogans' && sceneId !== 5"
          :data="item.children"
          :name="item.name"
          :min="item.restriction.min_length"
          :max="item.restriction.max_length"
          :description="item.description"
          :verify="verify"
          :required="item.required"
          :scene-id="sceneId"
          :words="words"
          @on-add="pushChild(item.restriction.origin_template, id)"
          @on-delete="delChild(id, ...arguments)"
          @on-select="selectDocument"
        />
        <smart-title
          v-else-if="item.name === 'captions'"
          :data="item.children"
          :name="item.name"
          :description="item.description"
          :min="item.restriction.min_length"
          :max="item.restriction.max_length"
          :verify="verify"
          :scene-id="sceneId"
          :words="words"
          @on-add="pushChild(item.restriction.origin_template, id)"
          @on-delete="delChild(id, ...arguments)"
          @on-select="selectDocument"
        />
        <smart-button
          v-else-if="item.name === 'action_bar'"
          v-model="item[item.name]"
          :name="item.name"
          :enumeration="item.restriction.enumeration"
          :default-value="item.restriction.default"
          :required="item.required"
          :description="item.description"
          :verify="verify"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="showSelectorModal"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      title="选择素材"
      width="1200px"
      append-to-body
      @close="onSelectorClose"
    >
      <AssetsSelector
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId: gameId }"
        @close="onSelectorClose"
        @confirm="uploadFileHandle"
      >
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled.cover"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData }">
          <el-select
            style="width: 160px"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.sizes"
            clearable
            multiple
            collapse-tags
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>

    <document v-model="docModel" :open-id="openId" @on-select="appendDocument" @on-cancel="docModel = false" />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import mixinUpload from './mixin-upload'

import SmartVideo from './smart-video'
import SmartCover from './smart-cover'
import SmartSticker from './smart-sticker'
import SmartSlog from './smart-slog'
import SmartButton from './smart-button'
import SmartTitle from './smart-title'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
export default {
  name: 'smartCreative',
  mixins: [mixinUpload],
  components: { SmartVideo, SmartSticker, SmartSlog, SmartButton, SmartTitle, Document },
  props: {
    value: {
      type: Number
    },
    data: {
      type: Array
    },
    sceneId: {
      type: Number,
      default: 1
    },
    media: {
      type: [String, Number]
    },
    source: {
      type: Array,
      default() {
        return []
      }
    },
    words: {
      type: Array
    },
    verify: {
      type: Boolean,
      default: false
    },
    gameId: {
      type: [String, Number],
      default: 0
    },
    openId: {
      type: [String, Number],
      default: ''
    },
    gameData: {
      type: Array
    },
    gameGroupData: {
      type: Array
    },
    operatorData: {
      type: Array
    },
    labelData: {
      type: Array
    }
  },
  computed: {
    smartCover: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    tempalteJson() {
      return isArray(this.data) && this.data.length ? this.data[0].template : []
    }
  },
  data() {
    return {
      smartVideo: 0,
      replaceImageId: 0,
      docModel: null,
      docType: '', // 选择文案的位置
      docMax: 0
    }
  },
  methods: {
    pushChild(template, index) {
      this.$emit('on-add', { item: template, index })
    },
    delChild() {
      const idx = arguments[0]
      const index = arguments[1]
      this.$emit('on-delete', [idx, index])
    },
    selectChild() {
      const idx = arguments[0]
      const index = arguments[1]
      this.$emit('on-sticker', [idx, index])
    },
    onSelectorClose() {},
    selectMedia() {
      const { param, item } = arguments[1]
      const template = arguments[0]
      const { name, type, width, height, size } = param
      const detailId = item.vertical || item.horizontal || this.smartVideo || 0
      const uploadType = this.switchToType(type)

      this.replaceImageId = param.imageId

      this.uploadBatch = null
      this.uploadSmart = 0
      // if (uploadType === 'cover' && detailId) this.uploadSmart = detailId
      if (uploadType === 'video') this.smartCreativeType = name
      this.uploadType = uploadType
      this.uploadWidth = width
      this.uploadHeight = height
      // this.uploadModel = true
      this.uploadMult = 1
      this.uploadName = name
      this.uploadSize = size
      this.uploadIndex = item.id
      this.setTemplate(template)

      let assetType = uploadType
      if (uploadType === 'cover' && detailId) {
        this.uploadSmart = detailId
        this.selectorProps.videoId = detailId
        assetType = 'poster'
      }
      this.selectorProps.form.sizes = [`${width}*${height}`]
      this.selectorProps.assetType = MATERIAL_TYPE_ID[assetType]
      this.selectorProps.max = this.uploadMult
      this.showSelectorModal = true
    },
    selectVideo(item) {
      item && (this.smartVideo = item[item.name])
    },
    clearVideo() {
      this.smartVideo = 0
    },
    selectDocument({ max, name, type }) {
      this.uploadName = name
      this.docModel = true
      this.docType = type
      this.docMax = max
    }
  },
  created() {
    if (isArray(this.tempalteJson) && this.tempalteJson.length > 5) {
      const { origin_template } = this.tempalteJson[5].restriction
      isArray(this.tempalteJson[5].children) && !this.tempalteJson[5].children.length && this.pushChild(origin_template, 5)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-creative {
  .c-smart-wrapper {
    position: relative;
  }
}
</style>
